import { Box, Flex, Icons, Page, Section, Typography } from 'components';
import Table, { TableProvider } from 'components/table';
import styled from 'styled-components';

const Icon = styled(Icons)`
  width: 12px;
  height: 12px;
  color: ${({ theme }) => theme.colors.white};
`;

const SquareLines = styled('i')`
  position: relative;
  position: absolute;
  left: 0;
  width: 0px;
  height: 0px;

  &::after {
    content: '';
    display: block;
    background-color: ${({ theme }) => theme.colors.primary_200};
    position: absolute;
    z-index: 1000;
  }

  &::before {
    content: '';
    display: block;

    border-top: 2px solid ${({ theme }) => theme.colors.white25};
    border-right: 2px solid ${({ theme }) => theme.colors.white25};
    position: absolute;

    right: 0px;
    z-index: 1;
  }

  ${({ theme: { mediaQueries } }) => {
    return `
    ${mediaQueries.mobile} {
      top: 1px;
      left: -25px;

      &::after {
        width: 14px;
        height: 14px;
      }

      &::before {
        top: -30px;
        width: 150px;
        height: 230px;
      }
    }

    ${mediaQueries.tablet} {
      left: -30px;

      &::after {
        width: 14px;
        height: 14px;
        top: 3px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 100px;
        height: 150px;
      }
    }

    ${mediaQueries.desktop} {
      top: 4px;
      left: -40px;

      &::after {
        width: 17px;
        height: 17px;
        top: 0px;
        left: 0px;
      }

      &::before {
        top: -40px;
        width: 150px;
        height: 280px;
      }
    }
  `;
  }}
`;

const ClassdiaryView = () => {
  const data = [
    {
      id: '27d8f86f-bd45-4d04-9c7c-8aec23474651',
      class: 'Introdução ao Direito Tributário',
      data: '2024-06-18T19:43:42.622Z',
      acao: 'Criou uma aula de video “nome da aula”',
      matricula: 4868963315,
      notaFinal: 0,
      mediaPresenca: 7,
      nota0: '8',
      nota0max: 2,
      nota1: '5',
      nota1max: 2,
      nota2: '7',
      nota2max: 2,
      nota3: '10',
      nota3max: 2,
      nota4: '10',
      nota4max: 2,
      presenca0: false,
      presenca1: true,
      presenca2: true,
      presenca3: true,
      presenca4: true,
      presenca5: true,
      presenca6: true,
      presenca7: true,
    },
    {
      id: 'aecbfac3-2703-4ab4-ba1a-a6dfeb166781',
      class: 'Análise combinatória',
      data: '2025-02-08T03:59:10.783Z',
      acao: 'Criou uma aula de video “nome da aula”',
      matricula: 3474654693,
      notaFinal: 0,
      mediaPresenca: 6,
      nota0: '9',
      nota0max: 2,
      nota1: '9',
      nota1max: 2,
      nota2: '9',
      nota2max: 2,
      nota3: '9',
      nota3max: 2,
      nota4: '9',
      nota4max: 2,
      presenca0: true,
      presenca1: true,
      presenca2: true,
      presenca3: false,
      presenca4: true,
      presenca5: false,
      presenca6: true,
      presenca7: true,
    },
    {
      id: '65dbfc43-87dc-48b6-9e43-9483e2f11750',
      class: 'Estatística Aplicada II',
      data: '2024-10-18T17:37:34.806Z',
      acao: 'Criou uma aula de video “nome da aula”',
      matricula: 3433294724,
      notaFinal: 0,
      mediaPresenca: 8,
      nota0: '8',
      nota0max: 2,
      nota1: '10',
      nota1max: 2,
      nota2: '6',
      nota2max: 2,
      nota3: '6',
      nota3max: 2,
      nota4: '6',
      nota4max: 2,
      presenca0: true,
      presenca1: true,
      presenca2: true,
      presenca3: true,
      presenca4: true,
      presenca5: true,
      presenca6: true,
      presenca7: true,
    },
    {
      id: 'e19acc52-8b5b-4c20-bd30-e0d322d3c6bc',
      class: 'Estatística Aplicada I',
      data: '2025-01-06T19:04:57.055Z',
      acao: 'Criou uma aula de video “nome da aula”',
      matricula: 6732525366,
      notaFinal: 0,
      mediaPresenca: 3,
      nota0: '8',
      nota0max: 2,
      nota1: '8',
      nota1max: 2,
      nota2: '8',
      nota2max: 2,
      nota3: '8',
      nota3max: 2,
      nota4: '8',
      nota4max: 2,
      presenca0: false,
      presenca1: true,
      presenca2: true,
      presenca3: false,
      presenca4: true,
      presenca5: false,
      presenca6: false,
      presenca7: false,
    },
  ];
  return (
    <Page title="Meus cursos">
      <Flex flexGrow={0} bg="navbarBg" mb={1}>
        <Section flexDirection={{ m: 'column', d: 'row' }} justifyContent="space-between">
          <Flex flexGrow={0} flexDirection="column" pt={{ m: 40, d: 40 }} pb={{ m: 60, d: 100 }}>
            <Box position="relative">
              <SquareLines />
              <Typography type="type5" color="white" fontWeight="bold" upper>
                Visualização do
              </Typography>
            </Box>

            <Typography type="type11" color="white" fontWeight="bold" mt={2}>
              Diário de Classe
            </Typography>
          </Flex>

          <Flex width={{ d: 420 }} ml={{ d: 60 }} flexShrink={0} flexGrow={0} />
        </Section>
      </Flex>

      <TableProvider>
        <Table
          objects={data}
          selectRowKey="id"
          fixedTop={103}
          properties={[
            {
              key: 'class',
              title: 'Usuário',
              options: {
                fixed: true,
                width: 250,
              },
            },

            {
              key: 'matricula',
              title: 'ID / Matrícula',
              render: (matricula) => {
                return <>{matricula}</>;
              },
            },
            {
              key: 'presenca0',
              title: 'aula 01',
              render: (presenca0: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca0 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca0 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca1',
              title: 'aula 02',
              render: (presenca1: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca1 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca1 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca2',
              title: 'aula 03',
              render: (presenca2: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca2 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca2 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca3',
              title: 'aula 04',
              render: (presenca3: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca3 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca3 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca4',
              title: 'aula 05',
              render: (presenca4: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca4 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca4 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca5',
              title: 'aula 06',
              render: (presenca5: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca5 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca5 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca6',
              title: 'aula 07',
              render: (presenca6: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca6 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca6 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },
            {
              key: 'presenca7',
              title: 'aula 08',
              render: (presenca7: boolean, { id }) => {
                return (
                  <Flex
                    flexGrow={0}
                    width={20}
                    p={1}
                    borderRadius={12}
                    bg={presenca7 ? 'primary_400' : 'gray_300'}
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Icon icon={presenca7 ? 'check' : 'close'} />
                  </Flex>
                );
              },
            },

            {
              key: 'mediaPresenca',
              title: 'Média de presença',
              render: (mediaPresenca) => {
                return (
                  <Flex width={75} justifyContent="center">
                    {(mediaPresenca / 8) * 100}%
                  </Flex>
                );
              },
            },

            {
              key: 'nota0',
              title: 'Nota Final',
              render: (nota0, { id, nota0max }) => {
                return (
                  <Flex width={80} alignItems="center" justifyContent="center" style={{ gap: 4 }} flexWrap="nowrap">
                    {nota0}
                    <Typography type="type1">/</Typography>
                    <Typography type="type1">{nota0max}</Typography>
                  </Flex>
                );
              },
            },

            {
              key: 'nota1',
              title: 'Nota 01',
              render: (nota1, { id, nota1max }) => {
                return (
                  <Flex width={80} alignItems="center" justifyContent="center" style={{ gap: 4 }} flexWrap="nowrap">
                    {nota1}
                    <Typography type="type1">/</Typography>
                    <Typography type="type1">{nota1max}</Typography>
                  </Flex>
                );
              },
            },

            {
              key: 'nota2',
              title: 'Nota 02',
              render: (nota2, { id, nota2max }) => {
                return (
                  <Flex width={80} alignItems="center" justifyContent="center" style={{ gap: 4 }} flexWrap="nowrap">
                    {nota2}
                    <Typography type="type1">/</Typography>
                    <Typography type="type1">{nota2max}</Typography>
                  </Flex>
                );
              },
            },

            {
              key: 'nota3',
              title: 'Nota 03',
              render: (nota3, { id, nota3max }) => {
                return (
                  <Flex width={80} alignItems="center" justifyContent="center" style={{ gap: 4 }} flexWrap="nowrap">
                    {nota3}
                    <Typography type="type1">/</Typography>
                    <Typography type="type1">{nota3max}</Typography>
                  </Flex>
                );
              },
            },

            {
              key: 'nota4',
              title: 'Nota 04',
              render: (nota4, { id, nota4max }) => {
                return (
                  <Flex width={80} alignItems="center" justifyContent="center" style={{ gap: 4 }} flexWrap="nowrap">
                    {nota4}
                    <Typography type="type1">/</Typography>
                    <Typography type="type1">{nota4max}</Typography>
                  </Flex>
                );
              },
            },
          ]}
        />
      </TableProvider>
    </Page>
  );
};

export default ClassdiaryView;
